import React, { Component } from 'react'
import styled from 'styled-components'

const ChipWrapper = styled.div`
  display: inline-block;
  .bordered-selector-input {
    opacity: 0;
    position:absolute;
    left:-999px;
  }
  .bordered-selector {
    position: relative;
    display: flex;
    align-items: center;
    border: 2px solid #D8D2D2;
    margin: 0 15px 15px 0;
    font-size: 14px;
    line-height: 22px;
    min-height: 40px;
    border-radius: 30px;
    &.green {
      border: 2px solid #00B178;
      color: #00B178;
    }
    &.disabled {
      background: #f4f4f4 !important;
      &:hover { 
        border-color: #D8D2D2;
        cursor: default !important;
        label {
          cursor: default !important;
        }
        &.green {
          border-color: #00B178;
        }
      }
    }
    .bordered-selector-label {
      margin: 0px;
      padding: 8px 35px 8px 20px;
      span { padding-right: 10px }
      i {
        margin: 2px;
        position: absolute;
        right: 10px;
        &::before {
          font-size: 17px;
          line-height: 20px;
        }
        &.green {
          padding: 0 4px 0 0;
          margin: 0;
          color: #00B178;
          border-radius: 20px;
          &::before {
            font-size: 22px;
            line-height: 22px;
          }
          &.indent {
            position: absolute;
            right: 10px;
          }
        }
      }
    }
    &:hover { 
      background: #f4f4f4;
      border: 2px solid #00B178;
      cursor: pointer;
    }
    &:active {
      background: #f4f4f4;
    }
  }
`

class ChipSelector extends Component {
  onHandleClick = () => {
    const { onClick, active, text, data_id: dataId, db_id: dbId, disabled } = this.props

    if (disabled) {
      return
    }

    onClick(active, text, dataId, dbId || '')
  };
  render() {
    const {
      accessId,
      active,
      icon,
      text,
      description,
      disabled
    } = this.props

    return (
      <ChipWrapper>
        <div className={`bordered-selector flex-box ${active ? 'green' : ''} ${disabled ? 'disabled' : ''}`}>
          <input
            id={`bordered-selector-${accessId}`}
            className="bordered-selector-input"
            type="checkbox"
            onChange={this.onHandleClick}
          />
          <label
            id={`bordered-selector-label-${accessId}`}
            htmlFor={`bordered-selector-${accessId}`}
            className={`bordered-selector-label ${
              icon === undefined ? 'no-icon' : ''
            }`}
          >
            <div className="info-content">
              <span className={active ? 'text-color-green font--bold' : ''}>
                {text}
              </span>
              {active ? (
                <i
                  className='icon-checkcircle green'
                />
              ) :
                icon && <i className={icon} />
              }
            </div>
          </label>
        </div>
        {description && <small>{description}</small>}
      </ChipWrapper>
    )
  }
}
export default ChipSelector
